<template>
  <v-container>
    <v-layout wrap row>
      <v-flex>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="merchants"
          :pagination.sync="pagination"
          :rows-per-page-items="rowPerPage"
          class="merchant-table"
        >
          <template slot="headers" slot-scope="props">
            <tr class="header-text">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', 'text-xs-left']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
            <tr class="header-filter">
              <th width="40%" colspan="2" class="text-xs-left">
                <span>Date:</span>
                <v-text-field
                  hide-details
                  readonly
                  class="calendar-picker"
                  placehlder="From"
                  v-model="filters.date_from.value"
                  @click="modalFrom = true"
                ></v-text-field>
                <v-text-field
                  hide-details
                  readonly
                  class="calendar-picker"
                  placehlder="To"
                  v-model="filters.date_due.value"
                  @click="modalTo = true"
                ></v-text-field>
              </th>
              <th width="30%" class="text-xs-left">
                <!-- <span>Merchants:</span> -->
                <v-select
                  hide-details
                  v-model="filters.merchant_login.value"
                  :items="merchantList"
                  label="Merchants"
                  append-icon="expand_more"
                  solo
                ></v-select>
              </th>
              <th width="30%" class="text-xs-left">
                <v-select
                  solo
                  hide-details
                  label="Status"
                  append-icon="expand_more"
                  item-text="text"
                  item-value="value"
                  :items="statusItems"
                  v-model="filters.status_physical.value"
                ></v-select>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.device_id }}</td>
            <td>{{ props.item.exp_date !== 'null' && props.item.exp_date ? props.item.exp_date.split(' ')[0] : 'null' }}</td>
            <td>{{ props.item.amount !== 'null' ? 'US $' + Math.round(props.item.amount * 100) / 10000 : 'US $0' }}</td>
            <td>{{ statusItems[props.item.status_physical] ? statusItems[props.item.status_physical].text : 'status' }}</td>
          </template>
          <template slot="footer">
            <td colspan="2"></td>
            <td>Total: US {{totalAmount}}$</td>
            <td></td>
          </template>
        </v-data-table>
        <v-dialog
          ref="dialogFrom"
          v-model="modalFrom"
          :return-value.sync="filters.date_from.value"
          persistent
          lazy
          full-width
          width="290px"
        >
          <v-date-picker v-model="filters.date_from.value" color="purple">
            <v-spacer></v-spacer>
            <v-btn flat color="purple" @click="modalFrom = false">Cancel</v-btn>
            <v-btn flat color="purple" @click="$refs.dialogFrom.save(filters.date_from.value)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
          ref="dialogTo"
          v-model="modalTo"
          :return-value.sync="filters.date_due.value"
          persistent
          lazy
          full-width
          width="290px"
        >
          <v-date-picker v-model="filters.date_due.value" color="purple">
            <v-spacer></v-spacer>
            <v-btn flat color="purple" @click="modalTo = false">Cancel</v-btn>
            <v-btn flat color="purple" @click="$refs.dialogTo.save(filters.date_due.value)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { addFilters } from "@/utils";

export default {
  name: "merchants",

  data: () => ({
    pagination: {
      sortBy: "device_id"
    },
    rowPerPage: [
      20,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    filters: {
      page: { value: 1 },
      merchant_login: { text: "All", value: "" },
      date_from: { value: "" },
      date_due: { value: "" },
      status_physical: { text: "All", value: "" }
    },
    headers: [
      {
        text: "Device id",
        align: "left",
        value: "device_id"
      },
      { text: "Date", value: "date" },
      { text: "Amount", value: "amount" },
      { text: "Status", value: "status" }
    ],
    merchants: [
      {
        device_id: "device_id",
        date: "date",
        amount: "amount",
        status: "status"
      }
    ],
    merchantList: [],
    statusItems: [
      { text: "In Stock", value: 0 },
      { text: "Awaiting for Activation", value: 1 },
      { text: "Activated", value: 2 },
      { text: "All", value: "" }
    ],
    modalFrom: false,
    modalTo: false,
    totalAmount: 0
  }),

  created() {
    this.init();
    axios
      .get(this.$hostname + "/admin/users?role=1", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      .then(response => {
        console.log(response);
        this.merchantList = response.data.data.map(merchant => {
          if (merchant.login.indexOf("+") > -1) {
            let val = merchant.login.split("");
            let newVal = val.map(symbol => {
              return symbol == "+" ? "%2B" : symbol;
            });
            return { text: merchant.login, value: newVal.join("") };
          } else {
            return { text: merchant.login, value: merchant.login };
          }
        });
        this.merchantList.push({ text: "All", value: "" });
      });
  },

  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    init() {
      let url = this.$hostname + "/admin/merchants/";
      axios
        .get(addFilters(url, this.filters), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.merchants = response.data.data;
        });
    }
  },

  watch: {
    filters: {
      handler() {
        this.init();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.merchant-table {
  .v-datatable {
    thead {
      background-color: #383838;
      .header-text {
        th,
        i {
          color: #fff !important;
        }
      }
      .header-filter {
        background-color: #fff;
        padding: 10px;
        th {
          color: #000;
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: 15px;
          text-align: center;
        }
      }
    }
  }
}

.calendar-picker.v-input {
  display: inline-block;
  width: inherit;
  margin-left: 15px;
  input {
    cursor: pointer;
  }
}
</style>
